import { useEffect } from "react";

const APPLE_PLATFORM = typeof navigator !== "undefined" && /Mac|iPhone|iPad|iPod/.test(navigator.userAgent);

/** How the command palette shortcut is shown (`label`) and announced (`aria-keyshortcuts`). */
export const PALETTE_SHORTCUT = APPLE_PLATFORM
  ? { label: "⌘K", aria: "Meta+K" }
  : { label: "Ctrl K", aria: "Control+K" };

export function isPaletteShortcut(event: KeyboardEvent): boolean {
  return (event.metaKey || event.ctrlKey) && !event.altKey && !event.shiftKey && event.key.toLowerCase() === "k";
}

/** Calls `onShortcut` when ⌘K / Ctrl+K is pressed anywhere on the page. */
export function usePaletteShortcut(onShortcut: () => void) {
  useEffect(() => {
    function onKeyDown(event: KeyboardEvent) {
      if (event.repeat || !isPaletteShortcut(event)) return;
      event.preventDefault();
      onShortcut();
    }
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onShortcut]);
}
